var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { useCallback, useState } from 'react';
import { uploadsApi } from 'apis/uploads';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/**
 * A hook that creates a presigned upload using the uploads endpoints and
 * uploads the file in one step.
 */
export const useUpload = () => {
    const dispatch = useAppDispatch();
    const [asyncStatus, setAsyncStatus] = useState('uninitialized');
    const [url, setUrl] = useState();
    const trigger = useCallback((arg) => __awaiter(void 0, void 0, void 0, function* () {
        setAsyncStatus('pending');
        try {
            const { data: { upload_url, download_url }, } = yield dispatch(uploadsApi.endpoints.createPresignedUrls.initiate(arg)).unwrap();
            yield axios.put(upload_url, arg.file, {
                headers: { 'Content-Type': arg.file.type },
            });
            setAsyncStatus('fulfilled');
            setUrl(download_url);
            return {
                asyncStatus: 'fulfilled',
                url: download_url,
            };
        }
        catch (_a) {
            setAsyncStatus('rejected');
            return {
                asyncStatus: 'rejected',
            };
        }
    }), [dispatch]);
    return [
        (arg) => trigger(arg),
        {
            asyncStatus,
            url,
        },
    ];
};
